import { render, staticRenderFns } from "./WeeklyWorkLabReply.vue?vue&type=template&id=073d4865"
import script from "./WeeklyWorkLabReply.vue?vue&type=script&lang=js"
export * from "./WeeklyWorkLabReply.vue?vue&type=script&lang=js"
import style0 from "./WeeklyWorkLabReply.vue?vue&type=style&index=0&id=073d4865&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports